var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skb-nav-bar",class:_vm.theme},[_vm._m(0),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"site-name"},[_c('span',{staticClass:"brand-name"},[_vm._v("IBM")]),_c('span',{staticClass:"product-name"},[_vm._v("SkillsBuild")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('span',{staticClass:"menu-item"},[_vm._v("TechTypeQuiz.com")])])
}]

export { render, staticRenderFns }